import { Dialog } from '@headlessui/react';
import { Dispatch, RefObject, useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import useSeeAllReuslts from '../../../lib/hooks/seeAllResults';
import { useAuth } from '../../../lib/providers/authProvider';
import Times from '../../icons/Times';
import StepFour from './StepFour';
import StepOne from './StepOne';
import StepThree from './StepThree';
import StepTwo from './StepTwo';

interface CareerQuizProps {
  initialState: boolean;
  resultsRef: RefObject<HTMLDivElement>;
  setPage: Dispatch<number>;
  potentialFilters: any;
  setPotentialFilters: Dispatch<any>
}

const CareerQuiz: React.FC<CareerQuizProps> = ({
  initialState,
  resultsRef,
  potentialFilters,
  setPotentialFilters,
  setPage,
}) => {
  const { seeker } = useAuth();
  let [isOpen, setIsOpen] = useState(initialState);
  const [step, setStep] = useState(1);
  const careerQuizForm = useForm();
  const [stepOneError, setStepOneError] = useState('');
  const [stepTwoError, setStepTwoError] = useState('');
  const [stepThreeError, setStepThreeError] = useState('');
  const { seeAllResults } = useSeeAllReuslts(
    setPage,
    potentialFilters,
    'careerguide',
  );

  const closeModal = () => {
    resultsRef.current?.scrollIntoView({ behavior: 'smooth' });
    setIsOpen(false);
    seeAllResults();
  };

  useEffect(() => {
    if (seeker && step == 4 && isOpen) {
      closeModal();
    }
  }, [seeker]);
  const next = () => {
    const { important, style, type } = careerQuizForm.getValues();
    switch (step) {
      case 1:
        if (style && style.length) {
          setStep(2);
        } else {
          setStepOneError('Please select at least one option.');
        }

        break;
      case 2:
        if (type) {
          setStep(3);
        } else {
          setStepTwoError('Please select at least one option.');
        }

        break;
      case 3:
        if (important) {
          setStep(4);
        } else {
          setStepThreeError('Please select at least one option.');
        }

        break;

      default:
        break;
    }
  };

  return (
    <Dialog
      open={isOpen}
      onClose={closeModal}
      className="relative z-50 w-screen h-screen md:w-62 md:h-auto"
    >
      <div
        className="fixed inset-0 hidden bg-black/30 md:block"
        aria-hidden="true"
      />
      <div className="fixed inset-0 flex md:items-center md:justify-center md:p-4">
        <Dialog.Panel className="flex flex-col justify-around w-screen md:w-256 max-w-screen md:rounded-5xl bg-white px-6 py-4 relative md:min-h-[650px] md:h-auto h-screen overflow-scroll items-stretch">
          <FormProvider {...careerQuizForm}>
            <Times
              onClick={closeModal}
              className="absolute self-start w-12 h-12 outline-none cursor-pointer top-4 right-4 stroke-careerPageHeading fill-careerPageHeading"
            />

            <div className="flex flex-col md:grid md:grid-cols-filter grid-rows-[auto 1fr] h-full w-full">
              {step == 1 && <StepOne error={stepOneError} />}
              {step == 2 && <StepTwo error={stepTwoError} />}
              {step == 3 && <StepThree error={stepThreeError} />}
              {step == 4 && (
                <StepFour
                  onSeeResults={closeModal}
                  setPotentialFilters={setPotentialFilters}
                />
              )}
              <div className="flex flex-col col-start-2 px-6 py-8 pb-32 md:flex-row lg:self-end md:pb-0">
                <div className="flex-1 mx-4">
                  <p className="text-4xl font-heading text-careerPageHeading">
                    <span className="text-6xl font-semibold ">{step}</span> of 4
                  </p>
                  <div className="relative">
                    <div className="w-full h-3 my-2 rounded-full bg-gnoIncLightBlue"></div>
                    <div
                      className={`absolute inset-0 rounded-full bg-gnoIncMdBlue h-3 ${
                        step === 1
                          ? 'w-1/4'
                          : step === 2
                          ? 'w-1/2'
                          : step === 3
                          ? 'w-3/4'
                          : 'w-5/6'
                      }`}
                    ></div>
                  </div>
                  {step != 4 && (
                    <button
                      onClick={closeModal}
                      className="self-end mb-2 font-bold underline font-base text-careerPageHeading"
                    >
                      Skip
                    </button>
                  )}
                </div>

                {step != 4 ? (
                  <button
                    onClick={next}
                    className="block w-auto my-4 mr-2 font-medium text-white border-2 border-solid md:my-0 rounded-gnoIncButton bg-careerPageHighlight hover:bg-white hover:text-careerPageHighlight border-careerPageHighlight min-w-gnoIncButton h-gnoIncButton font-heading"
                  >
                    Continue
                  </button>
                ) : (
                  <>
                    {!seeker && (
                      <button
                        onClick={closeModal}
                        className="self-end mb-2 font-bold underline font-base text-careerPageHeading"
                      >
                        Skip and see the results
                      </button>
                    )}
                  </>
                )}
              </div>
            </div>
          </FormProvider>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
};

export default CareerQuiz;
